/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Truncate from '../../Truncate';
import HoverIcon from '../../HoverIcon';
import { Context } from '../../../context/AppContext';
import filterProfileUrl from '../../../utils/filterProfileUrl';
import { ReviewStars } from '../../Review';

const ReviewsItem = ({ rating, name, businessName, message, profileUrl }) => {
  const {
    media: { mobile },
  } = useContext(Context);

  return (
    <div
      className={classNames('BusinessesList__ReviewsItem__root', {
        'BusinessesList__ReviewsItem__root--mobile': mobile,
      })}
    >
      <div className="BusinessesList__ReviewsItem__content">
        <Link
          to={filterProfileUrl(profileUrl)}
          className="BusinessesList__ReviewsItem__link"
        />

        {name && (
          <div className="BusinessesList__ReviewsItem__name">
            <span className="BusinessesList__ReviewsItem__nameLeft">
              {name}
            </span>{' '}
            <span className="BusinessesList__ReviewsItem__nameRight">
              left a review for
            </span>
          </div>
        )}
        {businessName && (
          <HoverIcon>
            <Link
              to={filterProfileUrl(profileUrl)}
              className="BusinessesList__ReviewsItem__businessName"
            >
              {businessName}
            </Link>
          </HoverIcon>
        )}
        <div className="BusinessesList__ReviewsItem__row">
          {!!rating && (
            <ReviewStars
              className="BusinessesList__ReviewsItem__stars"
              rating={rating}
              width={12}
            />
          )}
        </div>
        {message && (
          <Truncate lines={5}>
            <div className="BusinessesList__ReviewsItem__comment">
              {message}
            </div>
          </Truncate>
        )}
      </div>
    </div>
  );
};

export default ReviewsItem;
